import type { PropsWithChildren } from 'react';
import { useReveal } from '@/hooks/useReveal';

type RevealProps = PropsWithChildren<{
  delay?: number;
  className?: string;
  as?: 'div' | 'li' | 'article' | 'section';
}>;

export default function Reveal({ children, delay = 0, className = '', as = 'div' }: RevealProps) {
  const { ref, visible } = useReveal<HTMLDivElement>();
  const Tag = as as 'div';

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </Tag>
  );
}